


import { Component, Vue } from 'vue-property-decorator';

import SpotlightText, {
  SpotlightTextBorderType,
  SpotlightTextColor,
} from '@/shared/components/SpotlightText.component.vue';

@Component({
    components: {
      SpotlightText,
    },
})

export default class PartialSpotlightText extends Vue {
  private spotlightTextColor = SpotlightTextColor;
  private spotlightTextBorderType = SpotlightTextBorderType;
}
